<template>
  <div>
    <draggable 
      v-model="Data"
      tag="div"
      class="row"
      @end="ChangeBlockOrder(Data)"
      :options="{ handle: '.handle-block', class: 'row' }"
    >
      <b-col
        :id="'Section-' + Data + '-block-' + item.id"
        :key="'Section-' + Data + '-block-' + index"
        :md="item.col"
        v-for="(item, index) in Data"
        class="mb-2"
      >
        <div class="border p-2">
          <div class="d-flex justify-content-between align-items-center">
            <feather-icon
              icon="MenuIcon"
              size="18"
              class="cursor-pointer handle-block mr-2"
            />
            <div>
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="btn-icon rounded-circle mr-1"
                @click="updateBlock(index)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="btn-icon rounded-circle"
                @click="removeItem(index)"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </div>
          </div>
          <div class="mt-2 ql-editor">
            <h3 v-if="item.title">
              {{ item.title[currentLocale] }}
            </h3>
            <div
              class="mt-2"
              v-if="item.types == 'content'"
              v-html="item.content[currentLocale]"
            ></div>
            <div class="mt-2 text-center" v-else>
              <img :src="item.image" style="width: 100%" />
            </div>
          </div>
        </div>
      </b-col>
    </draggable>
  </div>
</template>

<script>
  import draggable from "vuedraggable";
  import Ripple from "vue-ripple-directive";
  import { ref, onUnmounted } from "@vue/composition-api";
  import store from "@/store";
  import { BRow, BCol, BSpinner, BButton, VBModal } from "bootstrap-vue";
  import "quill/dist/quill.core.css";
  
  export default {
    components: {
      draggable, BRow, BCol, BSpinner, BButton, VBModal,
    },

    props: {
      comData: {
        type: Object,
        required: false,
      },
      dataKey:{
        type: Number,
      },
      dataIndex:{
        type: Number
      },
    },

    directives: {
      "b-modal": VBModal,
      Ripple,
    }, 

    computed: {
      currentLocale() {
        return  this.$i18n.locale;
      },
    },

    setup(props, { emit }) {
      const BlocksRepeater = ref([]);
      const Data = ref(props.comData.blocks);
      const loadingBlock = ref(false);

      const ChangeBlockOrder = async (items) => {
        items.forEach((item, index) => {
          item.ordering_count = index + 1 
        })

        loadingBlock.value = true;
        emit("ordering-block", items);
      }
      
      const updateBlock = async (index) => {
       
        emit('update-block-data', index);
      };

      const removeItem = (index)=>{
        if(Data.value[index]){
          Data.value.splice(index,1)
        }

        emit('delete-block');
      }

      return {
        BlocksRepeater,
        Data,
        ChangeBlockOrder,
        loadingBlock,
        updateBlock,
        removeItem,
      };
    },

    methods: {
      even: function (arr) {
        // Set slice() to avoid to generate an infinite loop!
        return (Array.from(arr)??[]).slice().sort(function (a, b) {
          return a.ordering_count - b.ordering_count;
        });
      },
    },
  };
</script>
  